/**
 * @flow
 */

import React, { Component } from 'react'

import ResponsiveContainer from '../../core/ResponsiveContainer'

import styles from './styles.module.scss'
import Section from './components/Section'
import data from './utilities/data'
import {
  TitleContainer,
  Title,
  TitleUnderLine,
  FutureSection
} from './styledComponents'

type Props = {
  stakeholdersData: object,
  stakeholdersList: Array<object>,
  invertTheme: any
}

class FollowUsSection extends Component<Props> {
  renderStakeHolder = (stakeholder, index) => (
    <Section
      id={stakeholder.sectionId}
      key={stakeholder.title}
      futureItemBottomDescription={stakeholder.callToAction}
      futureItemDescription={stakeholder.description}
      futureItemSubTitle={stakeholder.tagline}
      futureItemTitle={stakeholder.title}
      imagePosition={index % 2 === 0 ? 'RIGHT' : 'LEFT'}
      rightButton={styles.rightButton}
      link={stakeholder.redirect}
      imagesPath={stakeholder.imagePath}
      mainImage={stakeholder.mainImage}
      mobileImage={stakeholder.mobileImage}
      applyText={stakeholder.apply}
      areahidden={data.moreSection.GamePublish.areahidden}
    />
  )

  render() {
    const { stakeholdersData, stakeholdersList, invertTheme } = this.props
    const { title, sectionId } = stakeholdersData
    return (
      <FutureSection
        id={sectionId}
        className={styles.futureSection}
        ref={c => {
          this.section = c
        }}
        invertTheme={invertTheme}
      >
        <ResponsiveContainer>
          <TitleContainer>
            <Title as="h2">{title}</Title>
            <TitleUnderLine invertTheme={invertTheme} />
          </TitleContainer>
          {stakeholdersList.map((stakeholder, index) =>
            this.renderStakeHolder(stakeholder, index)
          )}
        </ResponsiveContainer>
      </FutureSection>
    )
  }
}

export default FollowUsSection



// WEBPACK FOOTER //
// ./src/components/TeamNew/FollowUsSection/index.js